import { MglValidationService } from '../../../../../shared/services/MglValidationService';
import { AppApiService } from './AppApiService';
import { BasicValidationService } from '../../../../../shared/services/BasicValidationService';
import { MitgliedschaftGutscheinApi } from '../../../../../shared/models/generated/MitgliedschaftMitgliedschaftGutscheinApi';
import { AppFormModel } from '../models/AppFormModel';
import { AppModelAdapter } from '../helper/AppModelAdapter';
import { AppRateService } from './AppRateService';
import { User } from '../../../../../shared/models/api/User/User';

export class AppValidationService extends MglValidationService<MglAddMembersAppDefinition> {

	public static readonly SALESMAM_FIELDS = "#salesmanNo, #salesmanControlDigit";
	public static readonly OfficeaAvertisingKey = "#officeadvertisingkey";
	private readonly appApiService: AppApiService;
	private readonly appRateService: AppRateService;

	constructor(app: { options: MglAddMembersAppOptions }, forms: JQuery, user: User, cb: () => void = () => {
		//NOSONAR
	}) {
		super(app, forms, cb);
		this.appApiService = new AppApiService(this.options);
		this.appRateService = new AppRateService(this.options, user);
	}

	public addCustomMethods(): void {
		super.addCustomMethods();

		$.validator.addMethod('addfamilymembers', this.validatorAddFamilyMembers.bind(this));

		let mglratecheckMsg = "";
		$.validator.addMethod('mglratecheck', (value, element: HTMLInputElement) => {
			let isValid = false;
			this.appRateService.rateUpdateForValidation(() => {
				isValid = true;
			}, (data) => {
				[isValid, mglratecheckMsg] = this.evaluateMglRateCheckResponse(element, data);
			});

			return isValid;
		},
			() => mglratecheckMsg
		);
	}

	protected validatorAddFamilyMembers(): boolean {
		const $familyCheckboxes = this.$ctx.find(`input[name="familymember"]`);

		let oneSelected = false;
		$familyCheckboxes.each((index, checkbox) => {
			oneSelected = oneSelected || $(checkbox).is(':checked');
		});

		return oneSelected;
	}

	public validateSalesmenNo(formModel: AppFormModel,
		successCallback: () => void,
		errorCallback: (jqxhr: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string, profiWerbernummer: string) => void,
		showErrors = false,
		field?: HTMLInputElement): void {
		let reqStarted = false;
		const validation = this.getValidationApi();
		const successFunc = (): void => {
			successCallback();
			if (field) {
				$(AppValidationService.SALESMAM_FIELDS).attr(BasicValidationService.BACKEND_VALIDATION_ATTR, null);
				if (reqStarted) {
					validation.stopRequest(field, true);
					validation.element($(AppValidationService.SALESMAM_FIELDS));
					this.decorateElement(AppValidationService.SALESMAM_FIELDS);
				}
			}
		};
		if (!formModel.Profiwerbernummer) {
			successFunc();
			return;
		}
		if (field) {
			reqStarted = true;
			validation.startRequest(field);
		}
		this.appApiService.checkSalesmanNumbers(AppModelAdapter.getProfiwerberApi(formModel, this.options.app.advertisingkey),
			successFunc,
			(jqxhr, textStatus, errorThrown) => {
				errorCallback(jqxhr, textStatus, errorThrown, formModel.Profiwerbernummer);
				let id = "182000";
				if (showErrors && jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.Messages) {
					let msg = "", src = field.name;
					for (const errMsg of jqxhr.responseJSON.Messages) {
						if (errMsg.Id) {
							id = errMsg.Id;
							msg = errMsg.Message;
							if (errMsg.Source) {
								src = errMsg.Source;
								break;
							}
						}
					}
					const opts: { [key: string]: string } = {};
					if (field) {
						if (reqStarted) {
							validation.stopRequest(field, false);
						}
					} else {
						opts[this.lookupServerFieldnames[src] || "Profiwerbernummer"] = this.options.app.validationmessages.backend[`code_${id}`] || msg;
						this.showErrors(opts);
					}
				}
				if (field) {
					$(AppValidationService.SALESMAM_FIELDS).attr(BasicValidationService.BACKEND_VALIDATION_ATTR, id);
					if (showErrors) {
						validation.element($(AppValidationService.SALESMAM_FIELDS));
						this.decorateElement(AppValidationService.SALESMAM_FIELDS);
					}
				}
			});
	}

	public validateBonuscode(bonuscode: string,
		successCallback: () => void,
		errorCallback: () => void,
		field?: HTMLInputElement): void {
		let reqStatred = false;
		const validation = this.getValidationApi();
		const successFunc = (): void => {
			successCallback();
			if (field) {
				$(field).attr(BasicValidationService.BACKEND_VALIDATION_ATTR, null);
				if (reqStatred) {
					validation.stopRequest(field, true);
					validation.element($(field));
					this.decorateElement(field);
				}
			}
		};
		if (!bonuscode && field) {
			bonuscode = field.value;
		}
		if (!bonuscode) {
			errorCallback();
			return;
		}
		if (field) {
			reqStatred = true;
			validation.startRequest(field);
		}
		this.appApiService.checkBonuscode(
			new MitgliedschaftGutscheinApi({ GutscheinCode: bonuscode }),
			successFunc,
			(jqxhr: JQueryXHR) => {
				if (jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.Messages) {
					const messages = (jqxhr.responseJSON as ApiResponse<any>).Messages;
					for (const message of messages) {
						if (message.Id) {
							const id = message.Id.toString();
							this.setServerValidationBackendFlag(false, "Bonuscode", id);
							if (reqStatred) {
								validation.stopRequest(field, true);
							}
						}
					}
				}
				errorCallback();
			});
	}

	private getValidationApi(): {
		element: (element: JQuery) => void,
		startRequest: (element: HTMLInputElement) => void,
		stopRequest: (element: HTMLInputElement, bool: boolean) => void
	} {
		return $(this.forms)[0].validation;
	}

	public validateOfficeAdvertisingKey(officeAKey: string,
		successCallback: (isValid: boolean) => void,
		errorCallback: () => void,
		field?: HTMLInputElement): void {
		let startRequest = false;
		const validation = this.getValidationApi();
		const successFunc = (): void => {
			successCallback(true);
			if (field) {
				$(AppValidationService.OfficeaAvertisingKey).attr(BasicValidationService.BACKEND_VALIDATION_ATTR, null);
				if (startRequest) {
					validation.stopRequest(field, true);
					validation.element($(AppValidationService.OfficeaAvertisingKey));
					this.decorateElement(AppValidationService.OfficeaAvertisingKey);

				}
			}
		};
		if (!officeAKey && field) {
			officeAKey = field.value;
		}
		if (!officeAKey) {
			errorCallback();
			return;
		}
		if (field) {
			startRequest = true;
			validation.startRequest(field);
		}
		this.appApiService.checkMglWbs(officeAKey,
			successFunc,
			(jqxhr: JQueryXHR) => {
				if (jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.Messages) {
					this.setServerValidationBackendFlag(false, "GeschaeftsstellenWBS", '300000');
					if (startRequest) {
						validation.stopRequest(field, true);
					}
				}
				errorCallback();
			});
	}
}
